import React from 'react';
import { cn } from '../../../utils/cn';

const ModelLibraryCardShell = ({ accent = false, className, children }) => (
  <section
    className={cn(
      'flex flex-col h-full min-h-[320px] md:min-h-[380px]',
      'bg-card border border-border rounded-xl p-4 sm:p-5',
      'shadow-elevation-sm transition-smooth',
      accent && 'border-t-2 border-t-primary/35',
      className
    )}
  >
    {children}
  </section>
);

export default ModelLibraryCardShell;
